import React, { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { importSelectionFromTemplateFields } from "./utils";
import { useModalDisplay } from "../../../hooks/useModalDisplay";
import { GenericFormFields } from "../../generic-form/GenericFormBody";
import CreateEntityModal from "../../modals/create-entity";
import importSelectionFromTemplateSchema from "./ImportSelectionFromTemplate.schema";
import { useSelectionTemplates } from "../../../hooks/useSelectionTemplates";
import { EnumSelectionEntityType } from "../../../graphql/types/models/selections";

type ImportSelectionFromTemplateModalProps = {
  selectionEntityId?: string;
};

const ImportSelectionFromTemplateModal: React.FC<ImportSelectionFromTemplateModalProps> = (
  { selectionEntityId },
  ref
) => {
  const { shouldShow, hide } = useModalDisplay(ref);
  const { t } = useTranslation();

  const [formFields, setFormFields] = React.useState<
    GenericFormFields<{ templateId: string }>
  >({});

  const onSubmitImport = React.useCallback(() => {
    hide();
  }, []);

  const {
    selectionTemplates,
    importSelectionFromTemplate,
  } = useSelectionTemplates({
    onImport: onSubmitImport,
  });

  React.useEffect(() => {
    if (!selectionTemplates) return;
    setFormFields(importSelectionFromTemplateFields(t, selectionTemplates));
  }, [selectionTemplates, t]);

  const handleSubmit = React.useCallback(
    (values: { templateId: string }) => {
      importSelectionFromTemplate({
        variables: {
          ...values,
          selectionEntityId,
          selectionEntityType: EnumSelectionEntityType.SELECTION,
        },
      });
    },
    [importSelectionFromTemplate, selectionEntityId]
  );

  return (
    <CreateEntityModal
      validationSchema={importSelectionFromTemplateSchema(t)}
      className="import-selection-template"
      title={t("selections.importFromTemplate")}
      show={shouldShow}
      data={{
        templateId: "",
      }}
      submitText={t("common.import")}
      onSubmit={handleSubmit}
      onClose={hide}
      fields={formFields}
    />
  );
};

export default forwardRef(ImportSelectionFromTemplateModal);
